import update from "immutability-helper";
import {
  dataStorePut,
  getGlobalPreferencesFromState,
} from "../utils/userDataStore";
import { GLOBAL_PREFERENCES } from "../constants/siteEntranceExit";

import {
  SET_BREADCRUMB,
  SET_KEEP_ME_LOGGED_IN,
  SET_ERROR,
  ENABLE_POWER_USER_MODE,
  SET_VIEW_UNMATCHED,
} from "../constants/actionTypes";

export const setBreadcrumb = (breadcrumb, picture = null) => ({
  type: SET_BREADCRUMB,
  breadcrumb,
  picture,
});

export const setKeepMeLoggedIn = (bool) => ({
  type: SET_KEEP_ME_LOGGED_IN,
  payload: bool,
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error,
});

export const enablePowerUserMode = (bool) => ({
  type: ENABLE_POWER_USER_MODE,
  payload: bool,
});

export const setViewUnmatched = (name, bool, updateDataStore = true) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: SET_VIEW_UNMATCHED,
        payload: bool,
      });
      if (updateDataStore) {
        await dataStorePut(
          `${GLOBAL_PREFERENCES}_${name}`,
          update(getGlobalPreferencesFromState(name, getState()), {
            viewUnmatchedPhotos: { $set: bool },
          })
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
};
